interface CaretakerNameFields {
  firstName: string | null;
  lastName: string | null;
}

export function getCaretakerDisplayName(
  caretaker: CaretakerNameFields,
  fallback = 'Caregiver'
): string {
  const firstName = caretaker.firstName || '';
  const lastName = caretaker.lastName || '';
  return `${firstName} ${lastName}`.trim() || fallback;
}

export function getCaretakerAvatarUrl(
  caretaker: CaretakerNameFields & { avatar: string | null },
  fallbackLabel?: string
): string {
  if (caretaker.avatar) {
    return caretaker.avatar;
  }
  const name = fallbackLabel ?? getCaretakerDisplayName(caretaker);
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=random&color=fff&size=200`;
}
